export default __webpack_public_path__ + "static/media/Domenico Quirico il vincitore.1bd9bb5e.jpg";